export default __webpack_public_path__ + "static/media/Wasswa 2.ba6b047c.jpg";